import { Controller } from "@hotwired/stimulus";

// ■ このコントローラがやりたいこと
//   ページ送り（ページネーション）で表が切り替わると、新しいページは行数・行の高さが違うため
//   表全体の高さが変わる。ブラウザはスクロール量を保つので、表のすぐ下にある「下のページネーション」は
//   画面上で上下にズレてしまい、「次へ」を連打したいのに毎回位置が飛んでしまう。
//
// ■ どう解決するか
//   押したページネーションが「画面のどの高さにあったか」を押す直前に覚えておき、切り替わった後に
//   同じ高さへスクロールして戻す。これで押したページネーションがその場に留まり、連続でページ送りできる。
//   （＝「押す前に採寸 → 切り替え後にもう一度採寸 → ズレた差分だけスクロール」という仕組み）
//
// ■ なぜ要素を覚えず「上/下」で識別するか
//   押したページネーションの要素は切り替えで作り直されるため、参照を握っておいても無効になる。
//   そこで「上(top)か下(bottom)か」(data-pagination-position) で識別し、切り替え後に同じ側を探し直す。
export class PaginationScrollKeepController extends Controller {
  static targets = ["pagination"];

  // 切り替え前：押したページネーションの「上下どちら側か」と「画面上端からの距離」を記録する。
  record(event) {
    this.anchor = null; // ページ送りボタン以外（件数セレクト等）の押下では位置固定しないよう、まず消す
    const pagination = event.target
      .closest(".mypage-application__pagination-button") // 押したのがページ送りボタンか
      ?.closest(".mypage-application__pagination"); // そのボタンが属する上/下のページネーション枠
    if (!pagination) return;

    this.anchor = {
      // 上(top)・下(bottom)どちらのページネーションを押したか（切り替え後に同じ側を探す手がかり）
      side: pagination.dataset.paginationPosition,
      // 画面（ビューポート）上端から、そのページネーションまでの距離(px)
      viewportTop: pagination.getBoundingClientRect().top,
    };
  }

  // 切り替え後：同じ側のページネーションを探し、記録した距離まで戻るようウィンドウをスクロールする。
  restore(event) {
    // 記録が無い（ただの再描画）／この画面と無関係なフレームの読み込みなら何もしない
    if (!this.anchor || !this.element.contains(event.target)) return;

    const pagination = this.paginationTargets.find((el) => el.dataset.paginationPosition === this.anchor.side);
    if (pagination) {
      // 「いまの距離 − 記録した距離」＝ズレ量。その分だけスクロールすると元の高さに戻る。
      const delta = pagination.getBoundingClientRect().top - this.anchor.viewportTop;
      // behavior:"instant" は、ページ全体に効く滑らかスクロール(smooth)を打ち消して一瞬で合わせるため
      if (delta !== 0) window.scrollBy({ top: delta, left: 0, behavior: "instant" });
    }
    this.anchor = null; // 記録は使い切ったら消す（1回限り）
  }
}
